module.exports = __webpack_public_path__ + "img/1F92B.e4a9cbe7.svg";